/**
 * @module api-web:skuAutoExport/index
 * @description api for data/goods/skuAutoExport
 */
import service from '@/service'

/**
 * 新品开发统计列表
 * @param {{startDate:string,endDate:string}} params
 */
export function getFreshDevList(data) {
  return service['api-web']({
    url: '/data/product/skuAutoExport/getFreshDevList',
    method: 'post',
    data
  })
}

/**
 * 新品图片统计列表
 * @param {{startDate:string,endDate:string}} params
 */
export function getFreshPicList(data) {
  return service['api-web']({
    url: '/data/product/skuAutoExport/getFreshPicList',
    method: 'post',
    data
  })
}

/**
 * 无图的sku统计列表
 * @param {{startDate:string,endDate:string}} params
 */
export function getWithOutPicList(data) {
  return service['api-web']({
    url: '/data/product/skuAutoExport/getWithOutPicList',
    method: 'post',
    data
  })
}

/**
 * 新品开发统计导出
 * @param {{startDate:string,endDate:string}} params
 */
export function exportFreshDev(data) {
  return service['api-web']({
    url: '/data/product/skuAutoExport/exportFreshDev',
    method: 'post',
    data
  })
}

/**
 * 新品图片统计导出
 * @param {{startDate:string,endDate:string}} params
 */
export function exportFreshPic(data) {
  return service['api-web']({
    url: '/data/product/skuAutoExport/exportFreshPic',
    method: 'post',
    data
  })
}
